<style lang="stylus">
    .user-slider
        &.isTeamsApp
            @media screen and (max-width: 500px)
                display none
        .slider-container
            float left
            width 160px
            height 100%
            background #E5E7F4
            overflow auto
            border-right 1px solid rgba(242, 242, 242, 1)
            &::-webkit-scrollbar {
                width: 8px;
            }
            &::-webkit-scrollbar-track {
                -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
                border-radius:10px;
            }
            &::-webkit-scrollbar-thumb {
                border-radius:10px;
                background:rgba(0,0,0,0.1);
                -webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
            }
            .logobox
                display flex
                align-items center
                width 100%
                height 56px
                .logobox-img
                    display block
                .cn-icon
                    padding-left 24px
                .com-icon
                    padding-left 24px
                .board-icon
                    padding-left 21px

            .menu
                margin-top 18px
                &.small-fit
                    height calc(100% - 195px)
                    overflow-y scroll
                &::-webkit-scrollbar
                    width 8px
                    pointer-events none
                    background none
                &::-webkit-scrollbar-thumb
                    background #D2D3D6
                    border-radius 6px
                &::-webkit-scrollbar-track
                    background #fff
                &::-webkit-scrollbar-track-piece
                    background none
                &::-webkit-scrollbar-corner
                    background none
                &.pc-cn-bg
                    page_background()
                    &::-webkit-scrollbar-track
                        page_background()

                li
                    display flex
                    align-items center
                    position relative
                    height 40px
                    list-style none
                    overflow auto
                    user-select none
                    cursor pointer
                    font-size 14px
                    margin-bottom: 8px
                    &.short-text
                        .menu-text
                            width 68px
                    >img
                        display block
                        margin-left 14px
                    .menu-img
                        flex-shrink 0
                        margin-left 24px
                        width 24px
                        height 24px
                        fill #ffffff
                        stroke #ffffff
                    .board-menu-img
                        margin-left 24px
                    .menu-img-pc
                        flex-shrink 0
                        margin-left 20px
                        width 20px
                        height 20px
                        fill #ffffff
                        stroke #ffffff

                    .menu-text-online
                        margin-left 8px
                        color #000
                    .menu-text
                        font-size 13px
                        line-height 24px
                        margin-left 4px
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap

                    .meun-item-suffix
                        position absolute
                        right 16px
                        width 24px
                        height 24px
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: $box-radius;
                        &:hover
                            background-color rgba(255, 255, 255, 0.8)

                    &:hover:not(.active){
                        background-color rgba(204, 207, 221, 0.4)
                    }
                    &.active
                        color var(--themeColor)
                        .menu-text-online
                            font-weight 600

        .slider-content
            float left
            display flex
            flex 1
            background #fbfbfb
        .pc-slider
            width 180px
            background #ffffff
            border-right none
            .menu
                margin-top 12px
                li
                    width 100%
                    background-color white
                    margin 0
                    margin-bottom 2px
                    height 40px !important
                    overflow hidden !important
                    .menu-text
                        color #222
                        margin-left 8px
                        font-size 14px
                        font-weight 500
                    .menu-img
                        margin-left 16px
                        width 24px
                        height 24px
                    &:hover:not(.active)
                        slide_hover()

                .active
                    slide_active()
                    .menu-text
                        color #017FFF
                    &::after
                        display block
        .pc-slider.purple-theme__slider
            background #ffffff
            border-right 1px solid #e0e0e0
            .menu
                li
                    width calc(100% - 30px)
                    background-color  white
                    margin 4px 15px
                    height 40px !important
                    overflow hidden !important
                    border-radius 5px
                    &::after
                        display none
                        content ''
                        position absolute
                        right -4px
                        width 8px
                        height 24px
                        background #3a4275
                        border-radius 4px
                    .menu-text
                        color black
                    .menu-img-pc
                        fill #424242 !important
                        stroke #424242 !important
                    &:hover:not(.active)
                        background-color #ececf1 !important
                        .menu-text
                            color #3a4275
                        .menu-img-pc
                            fill #3a4275 !important
                            stroke #3a4275 !important

                .active
                    background-color #ececf1
                    .menu-text
                        color #3a4275
                    .menu-img-pc
                            fill #3a4275 !important
                            stroke #3a4275 !important
                    &::after
                        display block
        .pc-slider.dark-theme__slider
            background #343437
            border-right none
            .menu
                &::-webkit-scrollbar
                    width 8px
                    pointer-events none
                    background none
                &::-webkit-scrollbar-thumb
                    background #505055
                    border-radius 6px
                &::-webkit-scrollbar-track
                    background #343437
                .store-container
                    background #1e1e20 !important
                .external-nonework, .external-end
                    color #fff
                .notFound-title
                    color #fff
                li
                    background #343437
                    .menu-text
                        color #fff
                    .menu-img-pc
                        fill #fff !important
                        stroke #fff !important
                    &:hover:not(.active)
                        background rgba(255, 255, 255, 0.05) !important
                        .menu-text
                            color #017FFF
                        .menu-img-pc
                            fill #017FFF !important
                            stroke #017FFF !important
                .active
                    background rgba(255, 255, 255, 0.08)
                    .menu-text
                        color #017FFF
                    .menu-img-pc
                        fill #017FFF !important
                        stroke #017FFF !important
</style>

<template>
    <div class="user-slider" :class="{ isTeamsApp: isTeamsApp }">
        <Modal v-model="uploadState" :title="$t('importSuccess')" @on-ok="asyncOK">
            <p>{{ $t("isOpen") }}</p>
        </Modal>
        <input id="inputFile" type="file" accept=".eddx" style="display: none" @change="getFile($event.target.files[0])" />
        <div class="slider-container" :style="pcSliderFitWidth" :class="{ 'pc-slider': isPC, 'dark-theme__slider': isPCDarkMode == 2 }">
            <div class="logobox" id="logoBox" v-if="!isPC">
                <img
                    class="logobox-img"
                    :class="{
                        logoImgSea: lang !== 'zh',
                        'cn-icon': internal,
                        'com-icon': !internal,
                        'board-icon': isBoard,
                    }"
                    @click="tohome"
                    :src="logoIcon"
                    alt=""
                    :style="`${internal ? 'width:103px;height:24px;' : ''}`"
                />
            </div>
            <ul class="menu" :class="{ 'small-fit': smallScreen }">
                <template v-for="item in menuList">
                    <li
                        :key="item.id"
                        @click="clickMenu(item.id)"
                        @mouseenter="hoverId = item.id"
                        @mouseleave="hoverId = -1"
                        :title="$t(item.name)"
                        :data-locate="item.name"
                        :class="{
                            active: selectId === item.id,
                            myDocSlide: item.id === 1,
                            myShareSlide: item.id === 5,
                            'online-li': !isPC,
                            'short-text': item.id === 0,
                        }"
                    >
                        <img
                            v-if="isPC"
                            class="menu-img"
                            :src="
                                require(`@/home/assets/img/slider/pc/${
                                    selectId !== item.id && hoverId !== item.id ? item.img + themeIndex : item.img + '-active'
                                }.svg`)
                            "
                            alt=""
                        />
                        <img
                            v-else
                            class="menu-img"
                            :class="{ 'board-menu-img': isBoard }"
                            :src="require(`@/home/assets/img/slider/${selectId !== item.id ? item.img : item.img + '-active' + themeIndex}.svg`)"
                            alt=""
                        />
                        <p class="menu-text" :class="{ 'menu-text-online': !isPC }">{{ $t(item.name) }}</p>
                        <img v-if="item.id == 3 && showNewIcon" :src="newIcon" alt="" style="width: 32px; height: 15px" />
                        <img v-if="item.id == 10 && showNewIconTeam" :src="newIcon" alt="" style="width: 32px; height: 15px" />
                        <img v-if="item.id == 15 && showNewIconCourse" :src="newIcon" alt="" style="width: 32px; height: 15px" />
                        <div
                            v-if="item.id == 0"
                            class="meun-item-suffix"
                            @click="shortcutBoxVisible = !shortcutBoxVisible"
                            v-click-outside="closeBox"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M7 14.5C7 14.7761 7.22386 15 7.5 15C7.77614 15 8 14.7761 8 14.5V9H13.5C13.7761 9 14 8.77614 14 8.5C14 8.22386 13.7761 8 13.5 8H8V2.5C8 2.22386 7.77614 2 7.5 2C7.22386 2 7 2.22386 7 2.5V8H1.5C1.22386 8 1 8.22386 1 8.5C1 8.77614 1.22386 9 1.5 9H7V14.5Z"
                                    fill="#333333"
                                />
                            </svg>
                        </div>
                    </li>
                </template>
            </ul>
            <!-- bus事件需要，不可使用v-if -->
            <ShortcutBox v-show="shortcutBoxVisible"></ShortcutBox>
        </div>
        <Dilatancy />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import ShortcutBox from "@/public/components/ShortcutBox.vue";
    import appConfig from "@/public/globalConfig";
    import { directive as clickOutside } from "v-click-outside-x";
    import Dilatancy from "@/home/parts/Dilatancy.vue";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            ShortcutBox,
            Dilatancy,
        },
        directives: { clickOutside },
    })
    export default class Slider extends Vue {
        shortcutBoxVisible: boolean = false;
        newWindow: Window;
        uploadState = false;
        uploadFilePath = "";
        menuList: Array<any> = [
            {
                id: 0,
                name: "new",
                img: "newPageIcon",
            },
            {
                id: 1,
                name: "workbench",
                img: "cloudIcon",
            },
            {
                id: 10,
                name: "teams",
                img: "groupIcon",
            },
            {
                id: 8,
                name: "dropBox",
                img: "dropboxIcon",
            },
            // {
            //     id: 9,
            //     name: 'google',
            //     img: "gdIcon",
            // },
            {
                id: 2,
                name: "import",
                img: "importIcon",
            },
            // {
            //     id: 3,
            //     name: 'templates',
            //     img: "commuityIcon",
            // },
            {
                id: 4,
                name: "collect",
                img: "collectIcon",
            },
            // {
            //     id: 5,
            //     name: 'share',
            //     img: "shareIcon",
            // },
            {
                id: 6,
                name: "trash",
                img: "trashIcon",
            },
            // {
            //     id: 7,
            //     name: '选项',
            //     img: require('@/home/assets/img/user/slide/1-07.svg'),
            // },
        ];
        objWin: any;
        newIcon: object = require("@/home/assets/img/new.svg");
        showNewIcon: boolean = true;
        showNewIconTeam: boolean = true;
        showNewIconCourse: boolean = true;
        smallScreen: boolean = false;
        hoverId = -1;

        menuIconStyle(id) {
            if (id === 4) {
                return {
                    stroke: this.isPC ? "#424242" : "white",
                    fill: "none !important",
                };
            }
        }

        tohome() {
            if (this.isPlugin) {
                return;
            }
            if (this.isPrivate || this.isTeamsApp) {
                location.reload();
                return;
            }
            let url = `${window.location.origin}/?stay=1`;
            let arr = ["es", "fr", "de", "it", "pt"];
            if (!this.internal) {
                if (this.lang == "jp") {
                    url = "https://www.edrawsoft.com/jp/tour/edrawmax.html";
                } else if (arr.includes(this.lang)) {
                    url = `${window.location.origin}/${this.lang}/?stay=1`;
                }
            }
            window.open(url, "maxIndex");
            // if(this.objWin == null || this.objWin.closed) {
            //     // if(this.internal) {
            //     //     url += '?stay=1'
            //     // }
            //     this.objWin = window.open(url, 'maxIndex')
            // } else {
            //     window.open(url, 'maxIndex')
            // }
        }
        saveToLocal(key) {
            let storageData = JSON.parse(localStorage.getItem("slideTips"));
            let obj = {};
            if (storageData) {
                obj = storageData;
            }
            obj[key] = false;
            localStorage.setItem("slideTips", JSON.stringify(obj));
        }
        toMenu(id) {
            let langStr = this.lang || appConfig.language;
            id != 2 && id != 15 && (this.selectId = id);
            let urlSearch = location.search;
            switch (id) {
                case 0: {
                    // 新建
                    this.$router.push(`/${langStr}/new${urlSearch}`).catch((err) => {});
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
                case 1: {
                    // 云文件
                    if (this.isPC) {
                        this.$router.push(`/${langStr}/files`).catch((err) => {});
                    } else {
                        this.sensors.track("workbencButton", {
                            Catalogues: "Workbench",
                        });
                        this.$router.push(`/${langStr}/workbench${urlSearch}`).catch((err) => {});
                    }
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
                case 2: {
                    // 导入
                    if (!this.userInfo) {
                        this.$bus.$emit("login");
                    } else {
                        this.$track("Newpage", "import");
                        // if(appConfig.language != 'zh')
                        //     document.getElementById('inputFile').click()
                        // else
                        this.showImportModal = true; // 导入弹窗
                        this.$router
                            .push(`/${langStr}/workbench${urlSearch}`)
                            .then(() => {
                                setTimeout(() => {
                                    this.$bus.$emit("workbench_tomennu", 1);
                                }, 120);
                            })
                            .catch((err) => {});
                        this.selectId = 1;
                    }

                    break;
                }
                case 3: {
                    // 社区模板
                    if (!this.isPC) {
                        this.showNewIcon = false;
                        this.$router.push(`/${langStr}/store${urlSearch}`).catch((err) => {});
                        if (this.$route.name == "Store") {
                            // 刷新社区首页
                            if (!this.internal) {
                                this.$store.commit("setState", {
                                    type: "templateSelect",
                                    data: "index",
                                });
                            } else {
                                this.$store.commit("toTplCenter", {
                                    name: "activeAlbumID",
                                    data: -1,
                                });
                                this.$store.commit("toTplCenter", {
                                    name: "albumPageStatus",
                                    data: "default",
                                });
                            }
                        }
                    }
                    this.saveToLocal("newIcon");
                    break;
                }
                case 4: {
                    // 我的收藏
                    this.$router.push(`/${langStr}/collect${urlSearch}`).catch((err) => {});
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
                case 5: {
                    // 我的分享
                    // if(this.isPC){
                    //     this.$router.push(`/${langStr}/pcShare`).catch(err => {})
                    // }else{
                    //     this.$router.push(`/${langStr}/share`).catch(err => {})
                    // }
                    this.$router.push(`/${langStr}/share`).catch((err) => {});
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
                case 6: {
                    // 回收站
                    this.$router.push(`/${langStr}/recycle${urlSearch}`).catch((err) => {});
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
                case 7: {
                    // 选项
                    this.$router.push("/options").catch((err) => {});
                    break;
                }
                case 8: {
                    // DropBox
                    let ts: any = this;
                    if (!ts.$checkAuth({ type: "dropbox" })) return;
                    this.$router.push(`/${langStr}/dropbox${urlSearch}`).catch((err) => {});
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
                // case 9:{ // GoogleDrive
                //     let ts:any=this;
                //     if(!ts.$checkAuth({type:'googledrive'})) return;
                //     this.$router.push('/googledrive').catch(err => {})
                //     this.$store.commit('setState', {data: false, type: 'showLoading'})
                //     break
                // }
                case 10: {
                    // team
                    if (!this.isPC) {
                        this.showNewIconTeam = false;
                        this.saveToLocal("newIconGroup");
                    }
                    this.$router.push(`/${langStr}/teams${urlSearch}`).catch((err) => {});
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
                case 11: {
                    // pc 历史记录
                    this.$router.push(`/${langStr}/historyView${urlSearch}`).catch((err) => {});
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
                case 12: {
                    // 我的发布
                    this.$router.push(`/${langStr}/publishFile${urlSearch}`).catch((err) => {});
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
                case 13: {
                    // 星标文件
                    this.$router.push(`/${langStr}/starFile${urlSearch}`).catch((err) => {});
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
                case 14: {
                    // 分享给我
                    this.$router.push(`/${langStr}/ShareToMe${urlSearch}`).catch((err) => {});
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    break;
                }
                case 15: {
                    // 学堂
                    const url = "https://course.edrawsoft.cn/edrawmax";
                    this.showNewIconCourse = false;
                    this.saveToLocal("newCourse");
                    window.open(url, "_blank");
                    break;
                }
            }
        }
        clickMenu(id) {
            if (this.isPC && (<any>window).$qt && (<any>window).$qt.jsCallUpdateLoginTrigger) {
                if (id == 1) {
                    (<any>window).$qt.jsCallUpdateLoginTrigger("toUseCloudFile");
                } else if (id == 4) {
                    (<any>window).$qt.jsCallUpdateLoginTrigger("toViewCollectFile");
                } else if (id == 5) {
                    (<any>window).$qt.jsCallUpdateLoginTrigger("toViewSharedFile");
                } else if (id == 6) {
                    (<any>window).$qt.jsCallUpdateLoginTrigger("toUseRecycleBin");
                } else if (id == 13) {
                    (<any>window).$qt.jsCallUpdateLoginTrigger("toViewStarFile");
                } else if (id == 14) {
                    (<any>window).$qt.jsCallUpdateLoginTrigger("toViewSharedFile");
                }
            }
            if (id !== 0 && id !== 3) {
                if (!this.$validateLogin()) {
                    return;
                }
            }
            if (id == 3) {
                this.$gaTrack("Template_enterTemplateCommunity", `enterWay: fromTemplateEntry`);
                this.sensors.track("enterTemplateCommunity", {
                    Catalogues: "Templates",
                    enter_way: "fromTemplateEntry",
                    platform: this.isPC ? "desktop" : "online",
                });
            } else if (id == 2) {
                this.sensors.track("importButton", {
                    Catalogues: "openFileProcess",
                });
            } else if (id == 1) {
                this.sensors.track("clickToEnterPersonalCloud", {
                    Catalogues: "saveFileProcess",
                    savesource: "enterDeskSave",
                    user_login_state: this.$store.state.userInfo ? "loginUser" : "unloginUser",
                });
            }
            this.$store.commit("setState", { data: false, type: "showLoading" }); // 去除loadding动画
            this.$bus.$emit("closePreview"); // 关闭模板预览窗口
            this.$bus.$emit("closeUserWork"); // 关闭个人模板
            this.toMenu(id);
            (<any>window).$qt && (<any>window).$qt.jsCallWebUIDisplay && (<any>window).$qt.jsCallWebUIDisplay(); // 通知客户端ui渲染完成
        }
        getFile(file) {
            if (this.userInfo) {
                if (!file.name.endsWith("eddx")) {
                    this.$edMessage.error(this.$t("notSupportFile"));
                    return;
                }
                this.$store.commit("setState", { data: true, type: "showLoading" });
                let name = file.name.match(/(.*)\.eddx/i) && file.name.match(/(.*)\.eddx/i)[1];
                let list = [];
                this.$store.dispatch("getFloder", { prefix: "" }).then((res) => {
                    let folderList = res.data.data.folders || [];
                    let filesList = res.data.data.files || [];
                    filesList.map((item) => {
                        let list = item.key.split("/");
                        let n = list[list.length - 1];
                        n = n.match(/(.*)\.eddx/) && n.match(/(.*)\.eddx/)[1];
                        item.name = n;
                    });
                    filesList = filesList.filter((item) => {
                        if (item.key.match(/.+eddx$/)) {
                            return true;
                        }
                        return false;
                    });
                    filesList.forEach((fileItem) => {
                        let data = fileItem.name && fileItem.name.startsWith(name);
                        if (data) {
                            let res = fileItem.name.slice(name.length);
                            res = Number(res);
                            if (Number.isInteger(res)) {
                                list.push(res);
                            }
                        }
                    });
                    list = list.sort((a, b) => a - b);
                    if (list.includes(0)) {
                        (<any>this).$Modal.confirm({
                            title: this.$t("cover"),
                            content: this.$t("isCover"),
                            okText: this.$t("confirm"),
                            cancelText: this.$t("cancel"),
                            onOk: () => {
                                this.$store
                                    .dispatch("uploadFile", { file, name: name + ".eddx" })
                                    .then((res) => {
                                        this.uploadFilePath = res.path;
                                        this.uploadState = true;
                                        this.$store.commit("setState", {
                                            data: false,
                                            type: "showLoading",
                                        });
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                        if (err == "storage space not enough") {
                                            (<any>this).$edMessage.error(this.$t("space"));
                                        } else if (err !== "overLimit") {
                                            (<any>this).$edMessage.error(this.$t("uploadFail"));
                                        }
                                        this.$store.commit("setState", {
                                            data: false,
                                            type: "showLoading",
                                        });
                                    });
                            },
                            onCancel: () => {
                                for (let i = 0; i < list.length; i++) {
                                    if (list[i] + 1 != list[i + 1]) {
                                        name = file.name.match(/(.*)\.eddx/) && file.name.match(/(.*)\.eddx/)[1] + (list[i] + 1);
                                        break;
                                    }
                                }
                                this.$store
                                    .dispatch("uploadFile", { file, name: name + ".eddx" })
                                    .then((res) => {
                                        this.uploadFilePath = res.path;
                                        this.uploadState = true;
                                        this.$store.commit("setState", {
                                            data: false,
                                            type: "showLoading",
                                        });
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                        if (err == "storage space not enough") {
                                            (<any>this).$edMessage.error(this.$t("space"));
                                        } else if (err !== "overLimit") {
                                            (<any>this).$edMessage.error(this.$t("uploadFail"));
                                        }
                                        this.$store.commit("setState", {
                                            data: false,
                                            type: "showLoading",
                                        });
                                    });
                            },
                        });
                    } else {
                        this.$store
                            .dispatch("uploadFile", { file, name: name + ".eddx" })
                            .then((res) => {
                                this.uploadFilePath = res.path;
                                this.uploadState = true;
                                this.$store.commit("setState", {
                                    data: false,
                                    type: "showLoading",
                                });
                                this.sensors.track("generateCloudFile", {
                                    Catalogues: "openFileProcess",
                                    file_source: "importFile",
                                });
                            })
                            .catch((err) => {
                                console.log(err);
                                if (err == "storage space not enough") {
                                    (<any>this).$edMessage.error(this.$t("space"));
                                } else if (err == "overLimit") {
                                    (<any>this).$edMessage.error(this.$t("importOverLimit"));
                                } else if (err !== "overLimit") {
                                    (<any>this).$edMessage.error(this.$t("uploadFail"));
                                }
                                this.$store.commit("setState", {
                                    data: false,
                                    type: "showLoading",
                                });
                            });
                    }
                    console.log(name);
                    document.getElementById("inputFile")["value"] = "";
                });
            } else {
                let ts: any = this;
                ts.$bus.$emit("login");
            }
        }
        closeBox() {
            this.shortcutBoxVisible = false;
        }
        get isAd() {
            return this.$store.state.isAd;
        }
        asyncOK() {
            let ts: any = this;
            let maxAction = this.$store.state.appState;
            if (maxAction) {
                if (maxAction == "create") (<any>this).$edMessage.success(this.$t("create"));
                // else if(maxAction == 'share')
                //     (<any>this).$edMessage.success(this.$t('openTips'));
                return;
            }
            // localStorage.setItem('max_action', 'open')
            this.$gaTrack("openFileProcess_enterCanvas", `fileSource: importfile}`);
            if (this.openInTabs) {
                location.href =
                    window.location.origin + (<any>this.$router).options.base + "app.html?" + ts.$zipFileName("obj=" + this.uploadFilePath);
            } else {
                let fileObj = this.isAd ? "obj=" + this.uploadFilePath + `&from=ad` : "obj=" + this.uploadFilePath;
                window.open(window.location.origin + (<any>this.$router).options.base + "app.html?" + ts.$zipFileName(fileObj), this.uploadFilePath);
            }

            // this.$store.commit('setAppState','open');
            // let timer = setInterval(() => {
            //     if (!newTab.parent) {
            //         this.$store.commit("setAppState","");
            //         clearInterval(timer)
            //     }
            //     if (!newTab.location.hash) {
            //         this.$store.commit("setAppState","");
            //         clearInterval(timer)
            //     }
            // }, 500)
            // this.$store.state.winobj[this.uploadFilePath] = newTab;
            let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
            if (!openTabs.includes(this.uploadFilePath)) {
                openTabs.push(this.uploadFilePath);
            }
            localStorage.setItem("openTabs", JSON.stringify(openTabs));
        }
        get themeIndex() {
            return this.$store.state.themeIndex;
        }
        get logoIcon() {
            let lang = this.internal ? "zh" : "en";
            return require(`@/home/assets/img/logo-icon-${lang}.svg`);
        }
        get vipState() {
            if (this.isPC) {
                return this.$store.state.pcVip;
            } else {
                return this.$store.state.publicStore.vip;
            }
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }

        get selectId() {
            return this.$store.state.selectId;
        }

        set selectId(value) {
            this.$store.commit("setState", { data: value, type: "selectId" });
        }
        set showImportModal(v) {
            this.$store.commit("setState", {
                type: "showImportModal",
                data: v,
            });
        }
        get showImportModal() {
            return this.$store.state.showImportModal;
        }

        isChristmas: boolean = false;
        checkIsChristmas() {
            this.isChristmas = new Date().getTime() < new Date("2021-01-08 00:00:00").getTime();
        }
        checkScreen() {
            this.smallScreen = window.innerHeight < 485;
        }

        get pcSliderFitWidth() {
            if (this.isPC) {
                return {
                    width: `${this.$store.state.pcSliderFitWidth}px`,
                };
            }
            return "";
        }

        mounted() {
            this.checkScreen();
            let pathName = this.$route.name;
            if (pathName == "New") {
                this.selectId = 0;
            } else if (pathName == "Files" || pathName == "Workbench") {
                this.selectId = 1;
            } else if (pathName == "Store") {
                this.selectId = 3;
            } else if (pathName == "Share" || pathName == "PCShare") {
                this.selectId = 5;
            } else if (pathName == "Recycle") {
                this.selectId = 6;
            } else if (pathName == "Collect") {
                this.selectId = 4;
            } else if (pathName == "Dropbox") {
                this.selectId = 8;
            } else if (pathName == "Googledrive") {
                this.selectId = 9;
            } else if (pathName == "Teams") {
                this.selectId = 10;
            } else if (pathName == "HistoryView") {
                this.selectId = 11;
            } else if (pathName == "PublishFile") {
                this.selectId = 12;
            } else if (pathName == "StarFile") {
                this.selectId = 13;
            } else if (pathName == "ShareToMe") {
                this.selectId = 14;
            }
            let storageData = JSON.parse(localStorage.getItem("slideTips"));
            this.showNewIcon = storageData && typeof storageData.newIcon != "undefined" ? storageData.newIcon : true;
            this.showNewIconTeam = storageData && typeof storageData.newIconGroup != "undefined" ? storageData.newIconGroup : true;
            this.showNewIconCourse = storageData && typeof storageData.newCourse != "undefined" ? storageData.newCourse : true;
            if (this.isPC) {
                this.showNewIcon = false;
                this.showNewIconTeam = false;
                this.showNewIconCourse = false;
            }

            console.log(this.showNewIcon);
        }

        created() {
            window.addEventListener("resize", this.checkScreen);
            let menuList = [
                //  用到的id： 15
                {
                    id: 11,
                    name: "historyView",
                    img: "historyIcon",
                },
                {
                    id: 0,
                    name: "new",
                    img: "newPageIcon",
                },
                {
                    id: 1,
                    name: "workbench",
                    img: "cloudIcon",
                },
                {
                    id: 13,
                    name: "starFile",
                    img: "starFileIcon",
                },
                {
                    id: 3,
                    name: "templates",
                    img: "commuityIcon",
                },
                {
                    id: 15,
                    name: "course",
                    img: "courseIcon",
                },
                {
                    id: 10,
                    name: "teams",
                    img: "groupIcon",
                },
                {
                    id: 8,
                    name: "dropBox",
                    img: "dropboxIcon",
                },
                // {
                //     id: 9,
                //     name: 'google',
                //     img: "gdIcon",
                // },
                {
                    id: 2,
                    name: "import",
                    img: "importIcon",
                },
                {
                    id: 5,
                    name: "share",
                    img: "shareIcon",
                },
                {
                    id: 14,
                    name: "sharetome",
                    img: "sharetomeIcon",
                },
                {
                    id: 4,
                    name: "collect",
                    img: "collectIcon",
                },
                {
                    id: 12,
                    name: "publishFile",
                    img: "publishFileIcon",
                },
                {
                    id: 6,
                    name: "trash",
                    img: "trashIcon",
                },
                // {
                //     id: 7,
                //     name: '选项',
                //     img: require('@/home/assets/img/user/slide/1-07.svg'),
                // },
            ];
            if (this.isPrivate) {
                this.menuList = menuList.filter((item) => {
                    return [0, 1, 2, 6, 10].includes(item.id);
                });
            } else if (this.internal) {
                this.menuList = menuList.filter((item) => {
                    return [0, 1, 2, 3, 4, 6, 10, 15].includes(item.id);
                });
            } else {
                this.checkIsChristmas(); //海外判断是否处于圣诞节来展示圣诞帽，可结束后移除
                let list = this.isInclowdz ? [0, 1, 2, 3, 4, 6] : [0, 1, 2, 3, 4, 6, 8, 10];
                this.menuList = menuList.filter((item) => {
                    return list.includes(item.id);
                });
            }
            if (this.isPC) {
                this.menuList = menuList.filter((item) => {
                    if (item.id == 1) {
                        item.name = "cloud";
                    }
                    return [1, 4, 14, 6, 11, 12, 13].includes(item.id);
                });
            }
            if (this.isPlugin) {
                this.menuList = menuList.filter((item) => {
                    return [0].includes(item.id);
                    // return [0, 3].includes(item.id)
                });
            }
            if (this.isTeamsApp) {
                this.menuList = menuList.filter((item) => {
                    // 3, 4,
                    return [0, 1, 2, 6].includes(item.id);
                });
            }
            this.$bus.$on("changeSlide", (id) => {
                this.toMenu(id);
            });
            this.$bus.$on("importInclowdzFile", (data) => {
                this.toMenu(1);
                this.getFile(data);
            });
            this.$bus.$on("teamsappClickMenu", (id) => {
                this.clickMenu(id);
            });
        }
        beforeDestroy() {
            this.$bus.$off("changeSlide");
            this.$bus.$off("importInclowdzFile");
            this.$bus.$off("teamsappClickMenu");
            window.removeEventListener("resize", this.checkScreen);
        }
    }
</script>

<i18n>
{
  "zh": {
    "new": "新建",
    "cloud": "我的文档",
    "teams": "团队",
    "dropBox": "多宝箱",
    "google": "Google Drive",
    "import": "导入",
    "templates": "模板社区",
    "collect": "我的收藏",
    "share": "我的分享",
    "trash": "回收站",
    "workbench": "我的工作台",
    "historyView": "历史浏览",
    "publishFile": "我的发布",
    "starFile": "星标文件",
    "sharetome": "分享给我",
    "course": "亿图学堂",
    "login": "登录",
    "reg": "注册",
    "logout": "退出",
    "importSuccess": "导入成功",
    "isOpen": "是否立即打开？",
    "uploadFail": "上传失败，请重试",
    "space": "云空间已达上限， 删除文件或清理回收站",
    "cover": "提示",
    "isCover": "目标文件夹已存在同名文件，是否要覆盖？",
    "confirm": "覆盖",
    "openTips": "正在打开文件中，请稍后再试",
    "cancel": "不覆盖",
    "importOverLimit": "云文件超过限制，导入失败",
    "notSupportFile": "导入失败,不支持此文件类型",
    "dilatancy": "扩容"
  },
  "en": {
    "new": "New",
    "cloud": "My Documents",
    "teams": "Team",
    "dropBox": "Dropbox",
    "google": "Google Drive",
    "import": "Import",
    "templates": "Templates",
    "collect": "Favorites",
    "share": "Share",
    "trash": "Recycle Bin",
    "workbench": "Workbench",
    "historyView": "History",
    "publishFile": "Publish",
    "starFile": "Starred File",
    "sharetome": "Share with me",
    "course": "Edraw Academy",
    "login": "Login",
    "reg": "SignUp",
    "logout": "Logout",
    "importSuccess": "Import Completed",
    "isOpen": "Want to open it now?",
    "uploadFail": "Upload failed, please try again later.",
    "space": "Space storage not enough, delete files or upgrade to premium version to solve it.",
    "cover": "Tips",
    "isCover": "A file with the same name has already existed in the target folder，want to cover it?",
    "confirm": "Cover",
    "openTips": "Opening file, please try again later.",
    "cancel": "Cancel",
    "importOverLimit": "Importing failed, the amount of your flies has reached the upper limit.",
    "notSupportFile": "Importing failed, this file type is not supported",
    "dilatancy": "Expand Cloud Storage"
  },
  "fr": {
    "new": "Nouveau",
    "cloud": "Fichier cloud",
    "teams": "Équipes",
    "dropBox": "Dropbox",
    "google": "Google Drive",
    "import": "Importer",
    "templates": "Communauté de modèles",
    "collect": "Mes favoris",
    "share": "Ma part",
    "trash": "Corbeille",
    "workbench": "Mon établi",
    "historyView": "Navigation historique",
    "publishFile": "Publier",
    "starFile": "Fichier étoile",
    "sharetome": "Partage avec moi",
    "login": "s'identifier",
    "reg": "inscrit",
    "logout": "Quitter",
    "importSuccess": "Importation réussie",
    "isOpen": "Voulez-vous l'ouvrir immédiatement?",
    "uploadFail": "Échec du téléchargement, veuillez réessayer",
    "space": "L'espace cloud a atteint la limite supérieure, supprimer des fichiers ou nettoyer la corbeille",
    "cover": "Astuces",
    "isCover": "Un fichier du même nom existe déjà dans le dossier cible. Voulez-vous le remplacer?",
    "confirm": "Couverture",
    "openTips": "Ouverture du fichier, veuillez réessayer plus tard",
    "cancel": "Ne pas couvrir",
    "importOverLimit": "Le fichier cloud dépasse la limite, l'importation échoue",
    "notSupportFile": "L'importation a échoué, ce type de fichier n'est pas pris en charge",
    "dilatancy": "Etendre l'espace de stockage du Cloud"
  },
  "de": {
    "new": "Neu erstellen",
    "cloud": "Cloud -Datei ",
    "teams": "Mannschaften",
    "dropBox": "Dropbox",
    "google": "Google Drive",
    "import": "Importieren",
    "templates": "Vorlagen-Community",
    "collect": "Meine Favoriten",
    "share": "Mein Share",
    "trash": "Papierkorb",
    "workbench": "Meine Werkbank",
    "historyView": "Verlauf",
    "publishFile": "Veröffentlichen",
    "starFile": "Sternendatei",
    "sharetome": "Teile mit mir",
    "login": "Anmelden",
    "reg": "Registrieren",
    "logout": "Abmelden",
    "importSuccess": "Erfolgreich importiert",
    "isOpen": "Jetzt öffnen?",
    "uploadFail": "Upload fehlgeschlagen, bitte versuchen Sie es später erneut",
    "space": "Speicherplatz nicht ausreichend, Dateien löschen oder auf Premium-Version aktualisieren, um das Problem zu lösen",
    "cover": "Hinweis",
    "isCover": "Eine Datei mit demselben Namen ist bereits im Zielordner vorhanden. Möchten Sie sie ersetzen?",
    "confirm": "OK",
    "openTips": "Datei wird geöffnet. Versuchen Sie es später nch einmal",
    "cancel": "Abbrechen",
    "importOverLimit": "Import fehlgeschlagen, die Anzahl Ihrer Dateien hat die Obergrenze erreicht",
    "notSupportFile": "Import fehlgeschlagen, dieser Dateityp wird nicht unterstützt",
    "dilatancy": "Cloud-Speicher erweitern"
  },
  "jp": {
    "new": "新規作成",
    "cloud": "クラウドファイル",
    "teams": "チーム",
    "dropBox": "Dropbox",
    "google": "Google Drive",
    "import": "インポート",
    "templates": "テンプレート",
    "collect": "お気に入り",
    "share": "共有",
    "trash": "ゴミ箱",
    "workbench": "ワークベンチ",
    "historyView": "閲覧履歴",
    "publishFile": "投稿",
    "starFile": "スターファイル",
    "sharetome": "私との共有",
    "login": "ログイン",
    "reg": "登録",
    "logout": "ログアウト",
    "importSuccess": "インポートに成功しました",
    "isOpen": "すぐに開きますか？",
    "uploadFail": "アップロードできませんでした。もう一度お試しください",
    "space": "クラウドスペースが上限に達した、ファイルを削除、またはごみ箱をクリーンアップしてください",
    "cover": "ご注意",
    "isCover": "同じ名前のファイルがターゲットフォルダに既に存在します。上書きしますか？",
    "confirm": "確認",
    "openTips": "ファイルを開いています。しばらくしてからもう一度お試しください",
    "cancel": "キャンセル",
    "importOverLimit": "クラウドファイルが制限を超えているため、インポートは失敗します",
    "notSupportFile": "インポートに失敗しました。このファイル形式はサポートされていません",
    "dilatancy": "容量の追加"
  },
  "es": {
    "new": "Nuevo",
    "cloud": "Mis documentos",
    "teams": "equipos",
    "dropBox": "Dropbox",
    "google": "Google Drive",
    "import": "Importar",
    "templates": "Comunidad",
    "collect": "Favoritos",
    "share": "Compartir",
    "trash": "Papelera",
    "workbench": "Mi banco de trabajo",
    "historyView": "Historial",
    "publishFile": "Publicar",
    "starFile": "Estrellas archivos",
    "sharetome": "Comparte con",
    "login": "Iniciar sesión",
    "reg": "Regístrate",
    "logout": "Cerrar sesión",
    "importSuccess": "Importación completada",
    "isOpen": "¿Quieres abrirlo ahora?",
    "uploadFail": "Error al subir, intente nuevamente más tarde.",
    "space": "El espacio de almacenamiento no es suficiente, elimine archivos o actualice a la versión premium para resolverlo",
    "cover": "Consejos",
    "isCover": "Ya ha existido un archivo con el mismo nombre en la carpeta de destino, ¿quiere cubrirlo?",
    "confirm": "Comfirmar",
    "openTips": "Abriendo el archivo, por favor intente más tarde",
    "cancel": "Cancelar",
    "importOverLimit": "Error al importar, la cantidad de moscas ha alcanzado el límite superior",
    "notSupportFile": "Error al importar, este tipo de archivo no es compatible",
    "dilatancy": "Ampliar espacio en la nube"
  },
  "pt": {
    "new": "Novo",
    "cloud": "Os Meus Documentos",
    "teams": "times",
    "dropBox": "Dropbox",
    "google": "Google Drive",
    "import": "Importar",
    "templates": "Comunidade de modelos",
    "collect": "Favoritos",
    "share": "Partilhar",
    "trash": "Pasta de Reciclagem",
    "workbench": "Minha bancada de trabalho",
    "historyView": "Navegação Histórica",
    "publishFile": "Publicar",
    "starFile": "Documentos Estrelados",
    "sharetome": "Compartilhe comigo",
    "login": "Conectar",
    "reg": "Registrar-se",
    "logout": "Desconectar",
    "importSuccess": "Importação Concluída",
    "isOpen": "Deseja abrir agora?",
    "uploadFail": "Falha ao carregar, por favor, tentar mais tarde.",
    "space": "Espaço de armazenamento insuficiente, eliminar ficheiros ou fazer upgrade para a versão premium para resolver o problema.",
    "cover": "Dicas",
    "isCover": "Já existe um ficheiro com o mesmo nome na pasta de destino, deseja substituir o ficheiro?",
    "confirm": "OK",
    "openTips": "Abrindo ficheiro, por favor, tentar mais tarde.",
    "cancel": "Cancelar",
    "importOverLimit": "Falha ao importar, a quantidade de ficheiros atingiu o máximo superior.",
    "notSupportFile": "Falha ao importar, este tipo de ficheiro não é suportado",
    "dilatancy": "Expandir Armazenamento na Núvem"
  },
  "it": {
    "new": "Nuovo",
    "cloud": "I Miei Documenti",
    "teams": "Squadre",
    "dropBox": "Dropbox",
    "google": "Google Drive",
    "import": "Importa",
    "templates": "Comunità di modelli",
    "collect": "Preferiti",
    "share": "Condividi",
    "trash": "Cestino",
    "workbench": "Il mio banco da lavoro",
    "historyView": "Navigazione storica",
    "publishFile": "Pubblicare",
    "starFile": "File Stella",
    "sharetome": "Condividi con me",
    "login": "Accedi",
    "reg": "Registrati",
    "logout": "Esci",
    "importSuccess": "Importazione Completata",
    "isOpen": "Desideri aprirlo adesso?",
    "uploadFail": "Caricamento fallito. Si prega di riprovare più tardi.",
    "space": "Spazio di archiviazione insufficiente. Si prega di eliminare dei file o di eseguire l'upgrade alla versione premium.",
    "cover": "Suggerimenti",
    "isCover": "Esiste già un file con questo nome nella cartella di destinazione. Desideri sostituirlo?",
    "confirm": "OK",
    "openTips": "Apertura file in corso. Si prega di riprovare.",
    "cancel": "Annulla",
    "importOverLimit": "Importazione fallita. Il numero di file ha raggiunto il limite massimo.",
    "notSupportFile": "Importazione fallita. Tipo di file non supportato.",
    "dilatancy": "Espandi l'Archiviazione di Cloud"
  },
  "tw": {
    "new": "新建",
    "cloud": "我的檔案",
    "teams": "團隊",
    "dropBox": "Dropbox",
    "google": "Google Drive",
    "import": "導入",
    "templates": "模板社區",
    "collect": "我的收藏",
    "share": "我的分享",
    "trash": "回收站",
    "workbench": "我的工作台",
    "historyView": "歷史瀏覽",
    "publishFile": "發佈",
    "starFile": "星標檔案",
    "sharetome": "分享給我",
    "login": "登入",
    "reg": "註冊",
    "logout": "登出",
    "importSuccess": "導入成功",
    "isOpen": "是否立即打開？",
    "uploadFail": "上傳失敗，請重試",
    "space": "雲端硬碟已達上限， 刪除檔案或清理回收站",
    "cover": "提示",
    "isCover": "目標資料夾已存在同名檔案，是否要覆蓋？",
    "confirm": "覆蓋",
    "openTips": "正在打開檔案中，請稍後再試",
    "cancel": "不覆蓋",
    "importOverLimit": "雲端硬碟檔案超過限制，導入失敗",
    "notSupportFile": "導入失敗,不支持此檔案類型",
    "dilatancy": "擴充雲端硬碟儲存空間"
  },
  "kr": {
    "new": "새로 만들기",
    "cloud": "내 파일",
    "teams": "팀",
    "dropBox": "Dropbox",
    "google": "Google Drive",
    "import": "가져오기",
    "templates": "템플릿 갤러리",
    "collect": "즐겨찾기",
    "share": "공유",
    "trash": "휴지통",
    "workbench": "워크벤치",
    "historyView": "조회 기록",
    "publishFile": "게시한 파일",
    "starFile": "별표 파일",
    "sharetome": "사용자에게 공유된 파일",
    "login": "로그인",
    "reg": "가입",
    "logout": "로그아웃",
    "importSuccess": "가져오기 성공",
    "isOpen": "지금 열겠습니까？",
    "uploadFail": "업로드 실패, 다시 시도하세요.",
    "space": "클라우드 공간이 상한에 도달했습니다. 파일을 삭제하거나 휴지통을 청소하세요~",
    "cover": "팁",
    "isCover": "동일한 이름의 파일이 대상 폴더에 이미 있습니다. 덮어 쓰시겠습니까?",
    "confirm": "덮어쓰기",
    "openTips": "파일을 여는 중입니다. 나중에 다시 시도하세요~",
    "cancel": "덮어쓰지 않기",
    "importOverLimit": "클라우드 파일이 제한을 초과하여 가져 오기에 실패했습니다",
    "notSupportFile": "가져 오기에 실패했습니다.이 파일 형식은 지원되지 않습니다.",
    "dilatancy": "클라우드 스토리지 확장"
  },
  "id": {
    "new": "Baru",
    "cloud": "Dokumen Saya",
    "teams": "Tim",
    "dropBox": "Dropbox",
    "google": "Google Drive",
    "import": "Impor",
    "templates": "Templat",
    "collect": "Favorit",
    "share": "Bagikan",
    "trash": "Tempat Sampah",
    "workbench": "Meja kerja",
    "historyView": "Riwayat",
    "publishFile": "Terbitkan",
    "starFile": "File Berbintang",
    "sharetome": "Bagikan dengan saya",
    "login": "Masuk",
    "reg": "Daftar",
    "logout": "Keluar",
    "importSuccess": "Impor Selesai",
    "isOpen": "Ingin membukanya sekarang?",
    "uploadFail": "Gagal mengunggah. Coba lagi nanti.",
    "space": "Ruang penyimpanan tidak cukup. Hapus file atau tingkatkan ke versi premium untuk mengatasinya.",
    "cover": "Tip",
    "isCover": "File dengan nama yang sama sudah ada di folder target. Ingin menimpanya?",
    "confirm": "Timpa",
    "openTips": "Membuka file. Coba lagi nanti.",
    "cancel": "Batalkan",
    "importOverLimit": "Gagal mengimpor. Jumlah file telah melebihi batas.",
    "notSupportFile": "Gagal mengimpor. Jenis file ini tidak didukung",
    "dilatancy": "Tingkatkan Penyimpanan Cloud"
  }
}
</i18n>
